// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'

import { StyleSheet, Text, View } from '@react-pdf/renderer'
import PatientChartsPrintedFriendlySectionItemProperty from '../PatientChartsPrintedFriendlySectionItemProperty/PatientChartsPrintedFriendlySectionItemProperty'

const styles = StyleSheet.create({
  sectionItem: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginBottom: 8,
  },
  sectionItemTitle: {
    color: '#141414',
    textAlign: 'left',
    fontFamily: 'Helvetica-Bold',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: '700',
    marginBottom: 8,
  },
  allergySubTitle: {
    color: '#141414',
    textAlign: 'right',
    fontFamily: 'Helvetica-BoldOblique',
    fontSize: 12,
    fontStyle: 'italic',
    fontWeight: '700',
    marginBottom: 8,
  },
})
// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
const PatientChartsPrintedFriendlySectionItem = ({ propertyItemName, content, isAllergy, allergyName }) => (
  <View style={styles.sectionItem} wrap={false}>
    {propertyItemName ?
      <Text style={styles.sectionItemTitle}>{propertyItemName}</Text>
    : null}
    {/*
     // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered */}
    <View style={styles.sectionItemProperty}>
      {!!isAllergy && <Text style={styles.allergySubTitle}>{allergyName}</Text>}
      {/*
       // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered */}
      {content?.map(({ name, value }) => (
        <PatientChartsPrintedFriendlySectionItemProperty name={name} value={value} />
      ))}
    </View>
  </View>
)

export default PatientChartsPrintedFriendlySectionItem
